import { forwardRef } from "react";

import Icon from "@/components/Icon";
import RawIcon from "./RawUndoIcon.svg.jsx";

const UndoIcon = forwardRef((props, ref) => {
  return <Icon ref={ref} SvgComponent={RawIcon} {...props} />;
});

export default UndoIcon;
